export default "__VITE_ASSET__CiPuxv4E__"